import styled from 'styled-components';

export const BackButtonWrapper = styled.div`
  position: absolute;
  left: 0;
  height: 60px;
  width: 40px;
`;

export const BackButtonIconWrapper = styled.i`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;

  svg {
    transform: rotate(180deg);
  }
`;
